/**
 * 주요실적 > 기타
 */

import Nav from "../components/Nav";
import HeaderInner from "../components/HeaderInner";
import PerfEtcDetail from "../pages/PerfEtcDetail";
import Footer from "../components/main/Footer";
import Top from "../components/Top";
import * as zy from '../common/zeroyear-1.0.0';

export default function PerfEtcDetailRoute () {
    zy.navFuc();

    return (
        <>
        <Nav></Nav>
        <HeaderInner id="4"></HeaderInner>
        <PerfEtcDetail></PerfEtcDetail>
        <Footer></Footer>
        <Top></Top>
        </>
    );
}